"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    GraphConfig: function() {
        return GraphConfig;
    },
    updateShortcut: function() {
        return updateShortcut;
    }
});
const _dataservice = require("../data-service/data-service");
const _errorMessage = require("../errorMessage");
let GraphConfig = class GraphConfig {
    constructor(){
        this.formulas = [] // Formulas
        ;
        this.queries = [] // Queries
        ;
        this.keys = '' // Keys
        ;
    }
};
const updateShortcut = async (graphConfigs)=>{
    try {
        return await _dataservice.DataService.getInstance().updateShortcut(graphConfigs);
    } catch (err) {
        if (err instanceof _dataservice.DataServiceError) {
            if (err.status === 500) {
                (0, _errorMessage.errorMessage)('Unable to update shortcut.', 2000);
            } else {
                (0, _errorMessage.errorMessage)(err.message);
            }
        } else {
            (0, _errorMessage.errorMessage)(err);
        }
        return '';
    }
};
